<template>
    <div class="main-layout">
      <router-view />
    </div>
  </template>
    
  <script>
  export default {
    data() {
      return {
  
      }
    },
    methods: {
  
    }
  }
  </script>
    
  <style></style>